import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import Topbar from '../layout/Topbar';
import { getLog } from '../../actions/log';

const formattaData = (data) => new Date(data).toLocaleString('it-IT');

const COLORE_TIPO = {
  azione_admin: '#2563eb',
  errore_condomino: '#b00020',
  split_documento: '#7c3aed'
};

const ETICHETTA_TIPO = {
  azione_admin: 'Azione admin',
  errore_condomino: 'Errore condomino',
  split_documento: 'Split PDF'
};

const stileBadge = (colore) => ({
  display: 'inline-block',
  padding: '2px 10px',
  borderRadius: '999px',
  fontSize: '12px',
  fontWeight: 600,
  color: '#fff',
  backgroundColor: colore
});

const stileChip = (bg, colore) => ({
  display: 'inline-block',
  padding: '3px 9px',
  margin: '3px',
  borderRadius: '6px',
  fontSize: '12px',
  backgroundColor: bg,
  color: colore,
  whiteSpace: 'nowrap'
});

const stileContenitoreChip = {
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: '160px',
  overflowY: 'auto',
  padding: '6px',
  border: '1px solid #e5e5e5',
  borderRadius: '6px',
  backgroundColor: '#fafafa'
};

// Righe di split PDF: elenco sempre visibile (non nascosto dietro un click)
// di chi è stato associato a un condomino e chi no, con i rispettivi nomi.
const DettaglioSplit = ({ dettagli }) => {
  if (!dettagli) return null;
  const { trovati = [], nonTrovati = [], nonRiconosciute = [] } = dettagli;

  return (
    <div style={{ marginTop: '8px' }}>
      {trovati.length > 0 && (
        <div style={{ marginBottom: '6px' }}>
          <p style={{ margin: '0 0 4px 0', fontSize: '13px', fontWeight: 600, color: '#15803d' }}>
            ✓ Associati a un condomino ({trovati.length})
          </p>
          <div style={stileContenitoreChip}>
            {trovati.map((t, i) => (
              <span key={i} style={stileChip('#dcfce7', '#15803d')} title={t.condomino}>
                {t.nome} → {t.condomino}
              </span>
            ))}
          </div>
        </div>
      )}
      {nonTrovati.length > 0 && (
        <div style={{ marginBottom: '6px' }}>
          <p style={{ margin: '0 0 4px 0', fontSize: '13px', fontWeight: 600, color: '#b45309' }}>
            ✕ Non associati / in SCONOSCIUTI ({nonTrovati.length})
          </p>
          <div style={stileContenitoreChip}>
            {nonTrovati.map((t, i) => (
              <span key={i} style={stileChip('#fef3c7', '#b45309')} title={t.motivo}>
                {t.nome}
              </span>
            ))}
          </div>
        </div>
      )}
      {nonRiconosciute.length > 0 && (
        <div>
          <p style={{ margin: '0 0 4px 0', fontSize: '13px', fontWeight: 600, color: '#525252' }}>
            ? Pagine non interpretabili ({nonRiconosciute.length})
          </p>
          <div style={stileContenitoreChip}>
            {nonRiconosciute.map((t, i) => (
              <span key={i} style={stileChip('#e5e5e5', '#525252')} title={t.motivo}>
                pag. {(t.pagine || []).join(',')}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const VoceLog = ({ el }) => {
  const colore = COLORE_TIPO[el.tipo] || '#525252';
  return (
    <div style={{
      border: '1px solid #e5e5e5',
      borderLeft: `4px solid ${colore}`,
      borderRadius: '6px',
      padding: '10px 14px',
      marginBottom: '10px',
      backgroundColor: '#fff'
    }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
        <span style={stileBadge(colore)}>{ETICHETTA_TIPO[el.tipo] || el.tipo}</span>
        <span style={{ fontSize: '12px', color: '#666' }}>{formattaData(el.date)}</span>
        {el.condominioId && <span style={{ fontSize: '12px', color: '#666' }}>— {el.condominioId.nome}</span>}
      </div>
      <div style={{ fontSize: '14px' }}>{el.messaggio}</div>
      {el.tipo === 'split_documento' && <DettaglioSplit dettagli={el.dettagli} />}
    </div>
  );
};

const LogAttivita = ({ auth: { user, loading: loadingAuth }, log: { log, loading }, getLog }) => {

  useEffect(() => {
    getLog();
  }, []);

  if (user && user.ruolo !== 'admin') {
    return <Redirect to="/" />
  }

  return (loadingAuth || loading ? <Spinner /> :
    <div class="section lightblue user-block wf-section">
      <Topbar
        labelPagina={"Log attività"}
        isFolder={false}
      />
      <div class="w100">
        <div class="margin mt0">
          <p>Ultime {log.length} voci — azioni admin (creazione condomini/condominio, accettazioni), errori dei condomini (es. login falliti) e split PDF (estratti conto, bollettini).</p>
          <div>
            {log.map(el => <VoceLog key={el._id} el={el} />)}
          </div>
        </div>
      </div>
    </div>
  )
};

LogAttivita.propTypes = {
  auth: PropTypes.object.isRequired,
  log: PropTypes.object.isRequired,
  getLog: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  auth: state.auth,
  log: state.log
});

export default connect(mapStateToProps, { getLog })(LogAttivita);
